import { ApiResult } from 'interfaces/APITypes';

import { contentInstance, makeRequest } from './client';

export const getUser = async (id?: string): Promise<ApiResult> => {
  return makeRequest(contentInstance.get(`/users/${id}`));
};

export const getSetsForUser = async (id: string): Promise<ApiResult> => {
  return makeRequest(contentInstance.get(`/users/${id}/content-sets`));
};
